import { useTranslation } from 'react-i18next';

import { Badge, BadgeColor } from 'components/Display/Badge/Badge';

type ActionRequiredBadgeProps = {
  text?: string;
};

export const ActionRequiredBadge = ({ text }: ActionRequiredBadgeProps) => {
  const { t } = useTranslation();

  const displayText = text || t('common:actionRequired');

  return (
    <Badge color={BadgeColor.blue} type="indicator">
      {displayText}
    </Badge>
  );
};
